class CustomProductMain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(document).ready(function () {
        const $gallery = $(".product-gallery--desktop-carousel");
        const $viewblockmain = $(".product-info__offer-list");

        function handleScroll() {
          const scrollTop = $(window).scrollTop();
          const buyButtonsOffsetTop = $viewblockmain.offset().top;
          const galleryHeight = $gallery.outerHeight();
          const galleryBottom = scrollTop + galleryHeight;

          if (scrollTop <= 0 || galleryBottom >= buyButtonsOffsetTop) {
            if ($gallery.css("position") === "sticky") {
              $gallery.css("position", "");
              $gallery.removeClass("stickynotavailable");
            }
          } else {
            if ($gallery.css("position") !== "sticky") {
              $gallery.css("position", "sticky");
              $gallery.addClass("stickynotavailable");
            }
          }
        }

        function checkWindowSize() {
          if ($(window).width() <= 999) {
            $(window).on("scroll", handleScroll);
            handleScroll();
          } else {
            $(window).off("scroll", handleScroll);
            $gallery.css("position", "sticky");
            $gallery.removeClass("stickynotavailable");
          }
        }
        checkWindowSize();
        $(window).on("resize", checkWindowSize);
      });

      $(".product-slider-variant").css({ opacity: "1" });
      var swiper = new Swiper(".product-slider-variant", {
        slidesPerView: 2.1,
        spaceBetween: 8,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".variant-button-next",
          prevEl: ".variant-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 2.1,
            spaceBetween: 8,
          },
          400: {
            slidesPerView: 2.6,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1441: {
            slidesPerView: 3.8,
            spaceBetween: 10,
          },
        },
      });

      $(".product-gallery__zoom-popup")
        .unbind()
        .click(function () {
          var mediaUrl = "";
          var videoMedia = $(this)
            .parents(".product-gallery__media")
            .find("video-media");

          if (videoMedia.length > 0) {
            var videoTag = videoMedia.find("video");
            var videoSourceTag = videoTag.find("source");

            if (videoSourceTag.length > 0) {
              mediaUrl = videoSourceTag.attr("src");
            } else {
              mediaUrl = videoTag.attr("src");
            }
          } else {
            var imgTag = $(this).parents(".product-gallery__media").find("img");
            if (imgTag.length > 0) {
              mediaUrl = imgTag.data("src") || imgTag.attr("src");
            }
          }

          $(".custom-main-product-media").empty();
          if (mediaUrl.match(/\.(jpeg|jpg|gif|png)(\?.*)?$/i)) {
            // Create an img tag for the image
            var img = $("<img />", {
              src: mediaUrl,
              alt: "Dynamic Image",
              style: "max-width: 100%;",
            });
            $(".custom-main-product-media").append(img);
            $(".custom-main-product-media-container").show();
            $("body").css({ overflow: "hidden" });
          } else if (mediaUrl.match(/\.(mp4|webm|ogg)(\?.*)?$/i)) {
            var video = $("<video />", {
              controls: true,
              style: "max-width: 100%;",
            });
            var source = $("<source />", {
              src: mediaUrl,
              type: "video/mp4",
            });
            video.append(source);
            $(".custom-main-product-media").append(video);
            video[0].load();
            video[0].play();
            $("body").css({ overflow: "unset" });
            $(".custom-main-product-media-container").show();
          }
        });

      $(".overlay-media-popup")
        .unbind()
        .click(function () {
          $("body").css({ overflow: "unset" });
          $(".custom-main-product-media-container").hide();
          $(".custom-main-product-media").empty();
        });

      $(".product-media-close")
        .unbind()
        .click(function () {
          $("body").css({ overflow: "unset" });
          $(".custom-main-product-media-container").hide();
          $(".custom-main-product-media").empty();
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-product-main", CustomProductMain);

class CustomFeaturedChart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".swiperothercol", {
        spaceBetween: 0,
        slidesPerView: 1,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1225: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1441: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-featured-chart", CustomFeaturedChart);

class CustomShippingProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let sectionsToBundle = ["main-cart"];
      $(".addtocartcheckbox").change(function () {
        if (this.checked) {
          var id = $(this).attr("data-pid");
          var data = {
            quantity: 1,
            id: id,
            sections: sectionsToBundle.join(","),
          };
          $.ajax({
            url: "/cart/add.js",
            type: "POST",
            dataType: "json",
            data: data,
            success: async function (data) {
               $.ajax({
                    url: document.URL,
                    type: "GET",
                    success: function (data) { 
                      $("custom-free-shipping").html(
                        $(data).find("custom-free-shipping").html()
                      );
                      $("#main-cart-parent").html(
                        $(data).find("#main-cart-parent").html()
                      );
                    },
                  });
              // $("#main-cart-parent").load(
              //   document.URL + " #main-cart-parent",
              //   function () {
              //     $.ajax({
              //       url: document.URL,
              //       type: "GET",
              //       success: function (data) {
              //         $("custom-free-shipping").html(
              //           $(data).find("custom-free-shipping").html()
              //         );
              //         $(".order-summary__body").html(
              //           $(data).find(".order-summary__body").html()
              //         );
              //       },
              //     });
              //   }
              // );
            },
          });
        } else { 
          var id = $(this).attr("data-pid");
          $.ajax({
            url: "/cart/change.js",
            type: "POST",
            dataType: "json",
            data: {
              id: id,
              quantity: 0,
              sections: sectionsToBundle.join(","),
            },
            success: async function (data) {
              $.ajax({
                    url: document.URL,
                    type: "GET",
                    success: function (data) { 
                      $("custom-free-shipping").html(
                        $(data).find("custom-free-shipping").html()
                      );
                      $("#main-cart-parent").html(
                        $(data).find("#main-cart-parent").html()
                      );
                    },
                  });
              // $("#main-cart-parent").load(
              //   document.URL + " #main-cart-parent",
              //   function () {
                  
              //   }
              // );
            },
          });
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-shipping-product", CustomShippingProduct);

class ProductReviewTestimonial extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".product-review-testimonial", {
        spaceBetween: 10, 
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        }, 
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-review-blocks", ProductReviewTestimonial);


